module.exports = __webpack_public_path__ + "static/media/Jam3.f0e31c54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/Jam3.svg
// module id = 604
// module chunks = 0